<template>
  <header>
    <div class="top-bar bg-color">
    </div>
    <div class="nav-box nav-box_brand">
      <div id="boxFixed" :class="['nav-box-outer', isFixed ? 'fix' : '']">
        <div class="zeekr-container">
          <div class="col-lg-4 col-sm-4" style="padding: 0;" v-show="screenWidth < 768 ? false : !collapsed">
            <div class="logo">
              <router-link to="/zeekr" class="flex">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="#fffbf3" xmlns="http://www.w3.org/2000/svg" class="tween-icon" style="fill: rgb(35, 35, 35);"><path d="M25.6667 25.6667H18.6667V17.0226L11.6667 10.027V2.33114H25.6667V25.6667ZM2.33333 25.6667V2.33114H9.33334V10.9994L16.3333 17.995V25.6776L2.33333 25.6667ZM28 0H0V28H28V0Z"></path></svg>
              </router-link>
            </div>
          </div>
          <div class="col-lg-5 col-sm-5 col-xs-12 flex flex-center box-logo" style="padding: 0;">
            <router-link to="/zeekr" class="flex">
              <svg class="logo-center" width="114" height="14" viewBox="0 0 114 14" fill="#fffbf3" xmlns="http://www.w3.org/2000/svg" style="fill: rgb(35, 35, 35);"><path d="M16.7588 0.048261L5.77493 11.633H16.1841V14H0V13.9583L10.9838 2.37355H0.60937V0H16.7588V0.048261Z"></path><path d="M85.439 13.9912L75.2879 6.76747V13.9912H72.4688V0H75.2879V6.72798L85.1528 0H89.5073L79.6012 6.6863L89.8521 13.9912H85.439Z"></path><path d="M114.003 13.9912L106.313 8.76371H107.738C110.442 8.76371 112.823 7.19962 112.823 4.52554V4.34127C112.823 1.62551 110.423 0 107.636 0H96.3594V13.9912H99.1785V6.6863L109.805 13.9912H114.003ZM99.1959 2.36478H107.697C108.753 2.36478 109.731 2.80351 110.015 3.66123C110.07 4.25002 110.07 4.84274 110.015 5.43152C109.731 6.19273 108.753 6.66437 107.697 6.66437H99.1959V2.36478Z"></path><path d="M39.7392 11.5014V13.9912H25.3594V0H39.7392V2.48982H28.1048V5.49295H39.1277V7.98276H28.1048V11.4926L39.7392 11.5014Z"></path><path d="M63.2917 11.5014V13.9912H48.9141V0H63.2917V2.48982H51.6573V5.49295H62.6802V7.98276H51.6573V11.4926L63.2917 11.5014Z"></path></svg>
            </router-link>
          </div>
          <div class="box-right" style="padding: 0;" v-show="screenWidth < 768 ? true : false">
            <div class="toggle" @click="collapsed = !collapsed">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="#fffbf3" xmlns="http://www.w3.org/2000/svg" style="fill: rgb(35, 35, 35);"><g clip-path="url(#clip0_4274_5959)"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.5 8.45703H3.5V6.70703H24.5V8.45703ZM15.1667 14.8737H3.5V13.1237H15.1667V14.8737ZM3.5 21.2904H19.8333V19.5404H3.5V21.2904Z"></path></g><defs><clipPath id="clip0_4274_5959"><rect width="28" height="28"></rect></clipPath></defs></svg>
            </div>
            <transition name="fade">
              <nav v-show="screenWidth > 980 ? true : collapsed">
                <ul class="nav_brand">
                  <li class="nav_brand_li lang-mobile-li" v-show="collapsed && screenWidth < 980 ? true : collapsed">
                    <div class="lang-dropdown-inner">
                      <div class="lang-dropdown-region">Hong Kong, China</div>
                      <div class="lang-dropdown-options">
                        <div class="lang-dropdown-item" :class="{ active: $i18n.locale === 'zh' }" @click="selectLanguageMobile('zh', 1)">繁體中文</div>
                        <div class="lang-dropdown-item" :class="{ active: $i18n.locale === 'en' }" @click="selectLanguageMobile('en', 0)">English</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
            </transition>
          </div>
          <div class="col-lg-4 col-sm-4" style="padding: 0; position: relative;" v-show="screenWidth < 768 ? false : !collapsed">
            <div class="langBtn" @click.stop="langDropdown = !langDropdown">
              <svg width="20" height="20" viewBox="0 0 20 20" class="tween-icon" fill="#fffbf3" xmlns="http://www.w3.org/2000/svg" style="fill: rgb(35, 35, 35);"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.16683 11.8753C3.00332 11.2782 2.91602 10.6494 2.91602 10.0003C2.91602 9.35124 3.00332 8.72249 3.16683 8.12533H5.93857C5.86929 8.72799 5.83268 9.35558 5.83268 10.0003C5.83268 10.6451 5.86929 11.2727 5.93857 11.8753H3.16683ZM3.64086 13.1253C4.42613 14.7202 5.79374 15.9766 7.46618 16.6172C6.88006 15.7183 6.41682 14.515 6.13556 13.1253H3.64086ZM7.41351 13.1253C7.60236 13.97 7.86292 14.7175 8.17111 15.3338C8.85868 16.709 9.57727 17.0837 9.99935 17.0837C10.4214 17.0837 11.14 16.709 11.8276 15.3338C12.1358 14.7175 12.3963 13.97 12.5852 13.1253H7.41351ZM13.8632 13.1253C13.5818 14.515 13.1186 15.7183 12.5325 16.6172C14.2049 15.9766 15.5726 14.7202 16.3578 13.1253H13.8632ZM16.8318 11.8753H14.0601C14.1294 11.2727 14.166 10.6451 14.166 10.0003C14.166 9.35558 14.1294 8.72799 14.0601 8.12533H16.8318C16.9953 8.72249 17.0827 9.35124 17.0827 10.0003C17.0827 10.6494 16.9953 11.2782 16.8318 11.8753ZM12.8012 11.8753H7.1975C7.12307 11.2807 7.08268 10.6527 7.08268 10.0003C7.08268 9.34791 7.12307 8.71991 7.1975 8.12533H12.8012C12.8756 8.71991 12.916 9.34791 12.916 10.0003C12.916 10.6527 12.8756 11.2807 12.8012 11.8753ZM6.13556 6.87533H3.64086C4.42613 5.28053 5.79374 4.02405 7.46618 3.3834C6.88006 4.28229 6.41682 5.48568 6.13556 6.87533ZM8.17111 4.66678C7.86292 5.28316 7.60236 6.03063 7.41351 6.87533H12.5852C12.3963 6.03063 12.1358 5.28316 11.8276 4.66678C11.14 3.29163 10.4214 2.91699 9.99935 2.91699C9.57727 2.91699 8.85868 3.29163 8.17111 4.66678ZM13.8632 6.87533H16.3578C15.5726 5.28053 14.2049 4.02405 12.5325 3.3834C13.1186 4.28229 13.5818 5.48568 13.8632 6.87533ZM9.99935 18.3337C5.39697 18.3337 1.66602 14.6027 1.66602 10.0003C1.66602 5.39795 5.39697 1.66699 9.99935 1.66699C14.6017 1.66699 18.3327 5.39795 18.3327 10.0003C18.3327 14.6027 14.6017 18.3337 9.99935 18.3337Z"></path></svg>
              <div class="langBtn-l">{{ currentLangLabel }}</div>
              <svg class="langBtn-arrow" :class="{ open: langDropdown }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="rgb(35,35,35)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <transition name="fade">
              <div class="lang-dropdown" v-show="langDropdown">
                <div class="lang-dropdown-inner">
                  <div class="lang-dropdown-region">Hong Kong, China</div>
                  <div class="lang-dropdown-options">
                    <div class="lang-dropdown-item" :class="{ active: $i18n.locale === 'zh' }" @click="selectLanguage('zh', 1)">繁體中文</div>
                    <div class="lang-dropdown-item" :class="{ active: $i18n.locale === 'en' }" @click="selectLanguage('en', 0)">English</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <van-overlay z-index="100" :show="navChildOn" @click="changeNavChildOff" />
  </header>
</template>

<script>
import PubSub from 'pubsub-js'

export default {
  name: "Header",
  inject: ['reload'],
  data() {
    return {
      collapsed: false,
      navChildOn: false,
      langDropdown: false,
      screenWidth: document.body.clientWidth,
      isFixed: false,
      navList: [],
      navListChild: [],
      show: false,
      changeRed: 0,
    }
  },
  computed: {
    currentLangLabel() {
      return this.$i18n.locale === 'zh' ? 'Hong Kong, China/繁體中文' : 'Hong Kong, China/English'
    }
  },
  mounted() {
    let that = this
    that.navLists()

    if (that.$t('language.name') != '中文') {
      that.changeRed = 1
    } else {
      that.changeRed = 0
    }

    window.addEventListener('scroll', that.handleScroll)
    document.addEventListener('click', that.handleClickOutside)

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }

    that.getscreenWidth()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    changeCollapsed(e) {
      this.collapsed = false
      if (e == '') {
        this.navChildOn = true
      }
    },
    changeNavChildOff() {
      this.navChildOn = false
    },
    navLists() {
      let that = this
      that.navList = that.$t('navList_brand')
      that.navListChild = that.$t('navList_brand')[1].list
    },
    handleScroll() {
      requestAnimationFrame(() => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let offsetTop = document.querySelector('#boxFixed').scrollHeight - 50
        this.isFixed = scrollTop > offsetTop ? true : false
      })
    },
    changeLanguage(to, index) {
      this.$i18n.locale = to
      this.changeRed = index
      localStorage.setItem('languageSet', this.$i18n.locale)
      this.$store.commit('$_setLocale', this.$i18n.locale)
      PubSub.publish('locale', { locale: this.$i18n.locale })
      this.navLists()
      this.show = false
    },
    selectLanguage(to, index) {
      this.changeLanguage(to, index)
      this.langDropdown = false
    },
    selectLanguageMobile(to, index) {
      this.changeLanguage(to, index)
      this.collapsed = false
    },
    handleClickOutside(e) {
      var langBtns = this.$el.querySelectorAll('.langBtn')
      var dropdowns = this.$el.querySelectorAll('.lang-dropdown')
      var isInside = false
      for (var i = 0; i < langBtns.length; i++) {
        if (langBtns[i].contains(e.target)) { isInside = true; break }
      }
      if (!isInside) {
        for (var j = 0; j < dropdowns.length; j++) {
          if (dropdowns[j].contains(e.target)) { isInside = true; break }
        }
      }
      if (!isInside) {
        this.langDropdown = false
      }
    },
    getscreenWidth() {
      if (this.screenWidth >= 768) {
        this.show = false
        this.collapsed = false
      }
    }
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(() => {
          that.getscreenWidth()
          that.timer = false
        }, 200)
      }
    },
    navList(val) {
      if (this.navList.length != 0) {
        PubSub.publish('navs', this.navList)
      }
    },
    navListChild(val) {
      if (this.navListChild.length != 0) {
        PubSub.publish('navsChild', this.navList[1].list)
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* header */
header {
  position: relative;
  z-index: 100;
  font-family: 'Zeekr-Text-Regular', 'SF Pro Text', 'Hiragino Sans GB','Microsoft YaHei',sans-serif;;

  .container {
    padding: 0;
    justify-content: space-between
  }
  .zeekr-container {
    width: 95%;
    max-width: 1400px;
    height: 74px;
    line-height: 74px; 
    display: flex;
    margin: 0 auto;
    position: relative;
  }
  .box-right {
    display: flex;
    position: absolute;
    right: 0;
    height: 100%;
    .toggle {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    nav {
      position: fixed;
      top: 76px;
      left: 0;
      width: 100%;
      background: #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      z-index: 9998;
      padding: 16px 20px;
      line-height: normal;
      .nav_brand {
        flex-direction: column;
        .nav_brand_li {
          margin-right: 0;
          padding: 12px 0;
          border-bottom: 1px solid #f0f0f0;
          &:last-child {
            border-bottom: none;
          }
        }
        .lang-mobile-li {
          position: relative;
          padding: 10px 0;
          border-bottom: none;
          line-height: normal;

          .lang-dropdown-inner {
            background: #f5f5f5;
            border-radius: 6px;
            padding: 20px;
          }
          .lang-dropdown-region {
            font-size: 16px;
            font-weight: 600;
            color: #232323;
            margin-bottom: 14px;
          }
          .lang-dropdown-options {
            display: flex;
            align-items: center;
            gap: 40px;
          }
          .lang-dropdown-item {
            cursor: pointer;
            font-size: 14px;
            color: #666;
            padding-bottom: 4px;
            border-bottom: 2px solid transparent;
            transition: color 0.2s, border-color 0.2s;

            &:hover {
              color: #232323;
            }
            &.active {
              color: #232323;
              border-bottom-color: #232323;
            }
          }
        }
      }
    }
  }
  .flex {
    display: flex;
  }
  .flex-center {
    align-items: center;
    justify-content: center;
  }
  .menu{
    display: none;
  }

  a {
    cursor: pointer;
  }
  .langBtn {
    display: flex;
    align-items: center;
    justify-content: right;
    cursor: pointer;
    position: relative;
  }
  .langBtn-l {
    margin-left: 10px;
    font-size: 14px;
    color: rgb(35, 35, 35);
  }
  .langBtn-arrow {
    margin-left: 6px;
    transition: transform 0.3s ease;
    &.open {
      transform: rotate(180deg);
    }
  }
  .lang-dropdown {
    line-height: normal;
    position: absolute;
    top: 70px;
    right: 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    min-width: 260px;
    z-index: 10000;
    overflow: hidden;
    padding: 10px;

    .lang-dropdown-inner {
      background: #f5f5f5;
      border-radius: 6px;
      padding: 20px;
    }
    .lang-dropdown-region {
      font-size: 16px;
      font-weight: 600;
      color: #232323;
      margin-bottom: 14px;
    }
    .lang-dropdown-options {
      display: flex;
      align-items: center;
      gap: 40px;
    }
    .lang-dropdown-item {
      cursor: pointer;
      font-size: 14px;
      color: #666;
      padding-bottom: 4px;
      border-bottom: 2px solid transparent;
      transition: color 0.2s, border-color 0.2s;

      &:hover {
        color: #232323;
      }
      &.active {
        color: #232323;
        border-bottom-color: #232323;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
  .langCol {
    position: relative;
    padding: 10px 0;
    display: block;
    text-decoration: none;
    color: #394D45;
  }
  .nav-box_brand {
    height: 76px !important;
    .nav-box-outer {
      .container {
        display: flex;
        align-items: center;
      }
    }
    .nav_brand {
      display: flex;
      .nav_brand_li {
        margin-right: 46px;
        position: relative;
        &:nth-child(2) {
          margin-right: 0;
        }
        .nav_brand_list {
          position: absolute;
          top: 52px;
          left: -20px;
          background:#fff;
          width: 240px;
          .navChild_li {
            // border-top: 1px solid #dfdfdf;
            a {
              display: block;
              padding: 15px 20px;
              font-size: 15px;
            }
            a:hover {
              background: #0f0f0f;
              color: #fffbf3;
            }
          }
        }
      }
    }
    .logo {
      // margin-left: 20px;
      display: flex;
      justify-content: flex-start;
      height: 76px !important;
      line-height: 76px !important;
      a {
        display: flex;
        align-items: center;
        height: 76px !important;
        line-height: 76px !important;
      }
    }
  }
  .langCol_brand, .nav_brand, .li-lang_brand {
    font-size: 16px !important;
  }
  .li-lang_brand{
    padding-right: 22px !important;
  }
  .li-lang_brand.langTc {
    padding-right: 0 !important;
    padding-left: 22px !important;
  }

  .nav-box {
    background: #fff;
    // background: url('../picture/bg.jpg') repeat center top fixed;
    height: 76px;

    .nav-box-outer {
      position: relative;
      background-color: rgba(255, 255, 255, 0.9);
      box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px 0px;
      backdrop-filter: blur(4px);
      // box-shadow: 0 1.3px 0px #333;
      z-index: 9999;

      &.fix {
        position: fixed;
        top: 0;
        width: 100%;

        .logo {
          height: 76px !important;
          line-height: 76px !important;
        }

        nav {
          ul {
            li {
              a {
                // padding: 27px 30px 24px;
                // padding: 19px 30px 16px;
              }
            }
          }
        }
      }

      .logo {
        height: 76px !important;
        line-height: 76px !important;
        -webkit-transition: line-height 0.25s ease-in-out;
        -moz-transition: line-height 0.25s ease-in-out;
        -ms-transition: line-height 0.25s ease-in-out;
        -o-transition: line-height 0.25s ease-in-out;
        transition: line-height 0.25s ease-in-out;

        img {
          margin: 0;
          display: inline-block;
          max-width: 100%;
          width: 120px;
          height: auto;
          vertical-align: middle;
          -webkit-transition: max-height 0.25s ease-in-out;
          -moz-transition: max-height 0.25s ease-in-out;
          -ms-transition: max-height 0.25s ease-in-out;
          -o-transition: max-height 0.25s ease-in-out;
          transition: max-height 0.25s ease-in-out;
          -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
        }
      }

      nav {

        ul {
          li {
            position: relative;
            float: left;
            margin: 0;
            list-style: none;

            a {
              position: relative;
              // padding: 19px 30px 16px;
              display: block;
              font-size: 16px;
              font-weight: 400;
              text-decoration: none;
              text-align: left;
              color: #333;
              border-right: 1px solid rgba(255, 255, 255, 0.1);
              color: #333;
              &.is-active, &[aria-current='page'] {

                &:hover {
                  color: #222;
                  text-decoration: underline;
                }
              }

              &:hover {
                color: #394D45;
                text-decoration: underline;
              }
            }


            &:last-of-type, &:nth-last-of-type(2) {
              &::after {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  // @media (max-width: 1200px) {
  //   .langCol {
  //     padding: 19px 0 16px 18px !important;
  //   }


  //   .nav-box .nav-box-outer nav ul li a {
  //     font-size: 16px;
  //   }

  //   .nav-box_brand .nav_brand .nav_brand_li {
  //     margin-right: 38px;
  //   }
  //   .langCol_brand, .nav_brand, .li-lang_brand {
  //     font-size: 16px !important;
  //   }
  // }

  @media (max-width: 996px) {
    // .flex {
    //   margin-right: 6px;
    //   justify-content: flex-end;
    // }
    .menu {
      margin-left: 6px;
      margin-top: 3px;
      cursor: pointer;
      display: block;
    }
    button {
      margin-top: -5px;
      padding: 0;
      // margin-top: 6px;
      margin-bottom: 0;
      margin-right: 0;
      // padding: 9px 3px;
      border: none;
      background: transparent !important;
      position: relative;
      float: right;
      border-radius: 0px;
      cursor: pointer;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    .icon-bar {
      -webkit-transition: all 0.2s;
      -o-transition: all 0.2s;
      transition: all 0.2s;
      display: block;
      // width: 22px;
      // height: 2px;
      border-radius: 1px;
      background-color: #333;
    }

    .navbar-toggle:hover {
      background: transparent !important;
    }

    .navbar-toggle .icon-bar {
      margin-top: 5px;
      width: 27px;
      height: 3px;
      -webkit-transition: all 0.2s;
      -o-transition: all 0.2s;
      transition: all 0.2s;
    }

    .navbar-toggle .top-bar {
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
      -webkit-transform-origin: 10% 10%;
      -moz-transform-origin: 10% 10%;
      -ms-transform-origin: 10% 10%;
      transform-origin: 10% 10%;
    }

    .navbar-toggle .middle-bar {
      opacity: 0;
    }

    .navbar-toggle .bottom-bar {
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-transform-origin: 10% 90%;
      -moz-transform-origin: 10% 90%;
      -ms-transform-origin: 10% 90%;
      transform-origin: 10% 90%;
    }

    .navbar-toggle.collapsed .top-bar {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    .navbar-toggle.collapsed .middle-bar {
      opacity: 1;
    }

    .navbar-toggle.collapsed .bottom-bar {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    .nav-box_brand {
      .container  {
        height: 100%;
      }
    }

    //   height: 76px !important;
    //   .logo {
    //     line-height: 76px !important;
    //   }
    // }
    
    // .nav-box{
    //   .nav-box-outer{
    //     .logo{
    //       img {
    //         width: 90px;
    //       }
    //     }
    //   }
    // }

    // .langCol_brand {
    //   // padding-left: 0 !important;
    //   // margin-right: -12px !important;
    //   text-align: center;
    // }
    // .langCol_brand, .nav_brand, .li-lang_brand {
    //   font-size: 15px !important;
    // }
    // .li-lang_brand{
    //   padding-right: 20px !important;
    // }
    // .li-lang_brand.langTc {
    //   padding-left: 20px !important;
    // }
    // .nav_brand .nav_brand_li {
    //   margin-right: 0 !important;
    // }
    
    // .nav_brand {
    //   flex-direction: column;
    // }

    // nav {
    //   position: fixed;
    //   top: 118px;
    //   left: 0;
    //   width: 100%;
    //   background: #fff;
    //   -webkit-box-shadow: 0 1px 4px #999;
    //   box-shadow: 0 1px 4px #999;

    //   ul {
    //     width: 100%;

    //     li {
    //       width: 100%;

    //       a {
    //         font-size: 15px !important;
    //         padding: 20px 20px 20px !important;
    //         background-color: transparent;
    //         color: #000;
    //         text-align: center !important;
    //         border-bottom: 1px solid #ccc;
            
    //         &:hover {
    //           background: #0f0f0f;
    //           color: #fffbf2 !important;
    //         }
    //       }
          

    //       &:last-of-type {
    //         .langCol {
    //           padding: 20px 20px 20px !important;
    //         }
    //       }
    //     }
    //   }
    // }
  }
  @media (max-width: 768px) {

    .nav-box_brand {
      .container  {
        height: 100%;
      }
      // .box-logo {
      //   height: 100% !important;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header_Zeekr.vue